import { render, staticRenderFns } from "./keyboard.vue?vue&type=template&id=fb127bba&scoped=true"
import script from "./keyboard.vue?vue&type=script&lang=js"
export * from "./keyboard.vue?vue&type=script&lang=js"
import style0 from "./keyboard.vue?vue&type=style&index=0&id=fb127bba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb127bba",
  null
  
)

export default component.exports